import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { Form, Row, Col } from "react-bootstrap";
import { useForm } from "react-hook-form";
import axios from "axios";
import { showSuccessToast, showErrorToast } from "../../Utils/toastUtils";



const DeleteMany = (props) => {
    const modal = props.modal
    const setModal = props.setModal
    const deleteArray2 = props.data;
    const clearArrays = props.clearArrays;
    const getData = props.getData;


    const cancelDelete = (e) => {
        e.preventDefault();
        setModal(!modal)
    }

    const submitData = async (e) => {
        e.preventDefault()
        if(deleteArray2.length == 0){
            showErrorToast("Select atleast 1 seller");
            return
        }
        console.log("Deleting many")
        console.log(deleteArray2)
        // return;
        e.preventDefault()
        let data = axios.delete(`/api/sellers`, { data: { "ids": deleteArray2 } ,
            headers: {
                Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
            }
        })
            .then(response => {
                getData()
                clearArrays()
                showSuccessToast((response.data && response.data.Message) ? response.data.Message : "Success")
            }).then(() => getData())
            .catch(error => {
                showErrorToast("Error")
                console.error('Error making POST request:', error);
            });
            setModal(!modal)
            clearArrays()
    }

    return (
        <div>
            <Modal size="lg" backdropClassName="" isOpen={modal} toggle={() => setModal(!modal)}>
                <ModalHeader toggle={() => setModal(!modal)}>
                    Delete Many
                </ModalHeader>
                <ModalBody >
                    <form >
                        <div className="text-center">
                            Are you sure you want to delete?
                        </div>
                        <div className="text-center">
                            <button
                                type="submit"
                                className="btn bg-gradient-secondary w-30 my-5 mb-2 m-2"
                                onClick={(e) => cancelDelete(e)}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="btn bg-gradient-info  w-30 my-5 mb-2"
                                onClick={(e) => submitData(e)}
                            >
                                Delete
                            </button>
                        </div>
                    </form>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default DeleteMany;